.drawer {
    --bic-dialog-anchor-inline-max-width: 712px;
    width: min(var(--bic-dialog-anchor-inline-max-width), 100dvw);
}

.header {
    position: relative;
    padding: var(--bi-scale-4x) var(--bi-scale-4x) var(--bi-scale-16x);
    display: flex;
    flex-direction: column;
    align-items: flex-end;
    background: linear-gradient(0deg, var(--bi-primary-100) 0%, var(--bi-primary-95) 100%);
    overflow: clip;

    &::before,
    &::after {
        content: '';
        position: absolute;
        background: linear-gradient(180deg, var(--bi-primary-85) 0%, transparent 100%);
        pointer-events: none;
    }
    &::before {
        width: 289px;
        height: 180px;
        top: 0;
        left: 0;
        border-bottom-right-radius: var(--bi-scale-40x);

        @media (width < 768px) {
            width: 190px;
            height: 119px;
        }
    }
    &::after {
        width: 289px;
        height: 144px;
        bottom: 0;
        right: 0;
        border-top-right-radius: var(--bi-scale-40x);

        @media (width < 768px) {
            width: 190px;
            height: 95px;
        }
    }

    .headerContent {
        display: flex;
        flex-direction: column;
        gap: var(--bi-scale-2x);
        padding: 0 var(--bi-scale-4x);
        align-self: stretch;
        z-index: 1; /* Ensure header content is above pseudo-elements */

        @media (width < 768px) {
            padding: 0;
        }

        > p {
            font: var(--bi-font-title-bold-medium);
            color: var(--bi-color-text-accent);

            @media (width < 768px) {
                font: var(--bi-font-title-bold-xs);
            }

            > svg,
            > span {
                color: var(--bi-color-text-secondary);
                font-weight: var(--bi-font-weight-regular);
            }
            > svg {
                vertical-align: text-bottom;
                margin: 0 var(--bi-scale-0-25x);
            }
        }

        > h2 {
            font: var(--bi-font-headline-large);
            color: var(--bi-color-text);

            @media (width < 768px) {
                font: var(--bi-font-headline-small);
            }
        }
    }
}

.content {
    display: flex;
    flex-direction: column;
    overflow-y: auto;
    gap: var(--bi-scale-4x);
    padding: 0 var(--bi-scale-9x) var(--bi-scale-4x);

    @media (width < 768px) {
        padding: 0 var(--bi-scale-4x) var(--bi-scale-4x);
    }

    > h3 {
        margin-top: var(--bi-scale-12x);
        font: var(--bi-font-title-bold-medium);
        color: var(--bi-color-text-accent);
    }

    .description,
    .spinner {
        margin-top: var(--bi-scale-6x);
    }
}

.opportunitiesContent {
    display: flex;
    flex-direction: column;
    overflow-y: auto;
    padding: var(--bi-scale-12x) var(--bi-scale-9x);

    @media (width < 768px) {
        padding: var(--bi-scale-8x) var(--bi-scale-4x);
    }
}

.cards {
    display: flex;
    flex-direction: column;
}

.electives {
    display: flex;
    flex-direction: column;
    gap: var(--bi-scale-2x);
    list-style: none;
    margin: 0;
    padding: 0;
}
